import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import { GENERAL_FORM_FIELDS, GENERAL_FORM_FIELDS_NAMES } from '../../constants/merchant/general-form';

import './MerchantConfigurationInputBlock.scss';

interface ISwitchesProps {
    formik: any;
    formEditStatus: boolean;
    title: GENERAL_FORM_FIELDS_NAMES | string;
    formField: GENERAL_FORM_FIELDS | string;
    tooltip?: string;
    min?: number | null;
    max?: number | null;
    placeholder?: string;
}

export const MerchantConfigurationInputBlock = (props: ISwitchesProps): JSX.Element => {
    const { title, formik, formEditStatus, formField, tooltip, min, max, placeholder } = props;
    const { t } = useTranslation();

    const isDisabled = !formEditStatus;

    const handleChange = (event: any): void => {
        let minValue = null;

        if (min !== null) {
            minValue = isNaN(Number(min)) ? null : Number(min);
        }

        let maxValue = null;

        if (max !== null) {
            maxValue = isNaN(Number(max)) ? null : Number(max);
        }

        const value = event.target.value === '' || event.target.value === undefined ? '' : Number(event.target.value);
        if (event.target.value === '') {
            formik.setTouched({ [formField]: true });
            formik.setFieldValue(formField, undefined);
        } else if ((minValue === null || value >= minValue) &&
            (maxValue === null || value <= maxValue)) {
            formik.setTouched({ [formField]: true });
            formik.setFieldValue(formField, value);
        }
    };

    return (
        <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="me-3 fs-7">
                <span className={clsx('me-1', isDisabled && 'text-muted')}>{t(title)}</span>
                {
                    tooltip && (
                        <WhisperComponent
                            isTooltip
                            whisperText={tooltip}
                            mainText={
                                <FontAwesomeIcon
                                    icon={faQuestionCircle}
                                    className={clsx('cursor-pointer', isDisabled && 'text-muted')}
                                    width={12}
                                />
                            }
                        />
                    )
                }

            </div>

            {/*<Toggle*/}
            {/*    size="md"*/}
            {/*    checked={formik.getFieldProps(formField).value}*/}
            {/*    className={clsx(formik.getFieldProps(formField).value ? 'is-active' : '', isDisabled && 'toggle-muted')}*/}
            {/*    onChange={handleChange}*/}
            {/*    disabled={isDisabled}*/}
            {/*/>*/}

            <div className={clsx('merchant-configuration-input-wrapper', !isDisabled && 'isEditBG')}>
                <input
                    type="number"
                    className="number-input"
                    step="1"
                    lang="en"
                    placeholder={placeholder ?? ''}
                    onChange={handleChange}
                    value={formik.getFieldProps(formField)?.value ?? ''}
                    min={min !== null ? min : undefined}
                    max={max !== null ? max : undefined}
                    disabled={isDisabled}
                    onFocus={(): void => formik.setFieldTouched(formField, true)}
                />
            </div>
        </div>

    );
};
